import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowLeft = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.7072 4.29289C16.0977 4.68342 16.0977 5.31658 15.7072 5.70711L9.41421 12.0001L15.7072 18.293C16.0977 18.6835 16.0977 19.3167 15.7072 19.7072C15.3166 20.0978 14.6835 20.0978 14.293 19.7072L7.29289 12.7072C6.90237 12.3166 6.90237 11.6835 7.29289 11.293L14.293 4.29289C14.6835 3.90237 15.3166 3.90237 15.7072 4.29289Z", fill: color }));
};
export default factorySvgIcon(SvgArrowLeft);
//# sourceMappingURL=SvgArrowLeft.js.map